import React from 'react';
import { useLeadStatusTypesQuery, useRegionsListQuery } from 'api';
import { useFilters } from './useFilters';
import { CalendarIcon } from 'components/common/icons';
import { AdminSelect, Col, DatePicker, FilterDrawer, Form, FormInstance, Row, Select } from 'components';
import { ClientSelect } from 'components/common/clientSelect';
import { CountrySelect } from 'components/common/countrySelect';
import styles from 'pages/admin/clients/styles.module.scss';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { data: regions = [] } = useRegionsListQuery();
  const { data: statusTypes = [] } = useLeadStatusTypesQuery();
  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }} // Add space for drawer actions
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={applyFilters}
        initialValues={{
          clientId: null,
          countryId: null,
          region: null,
          statusId: null,
          createdDate: [null, null],
          lastUpdatedDate: [null, null],
        }}
      >
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="clientId" label="Client Name">
              <ClientSelect allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="region" label="Region">
              <Select mode={'multiple'} maxTagCount={'responsive'} options={regions} allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdBy" label="Created By">
              <AdminSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastUpdatedBy" label="Last Updated By">
              <AdminSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="countryId" label="Country">
              <CountrySelect allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="status" label="Status">
              <Select mode={'multiple'} options={statusTypes} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdDate" label="Created Date">
              <RangePicker
                format="DD.MM.YYYY"
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName="fmg-range-picker"
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastUpdatedDate" label="Last Updated">
              <RangePicker
                format="DD.MM.YYYY"
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName="fmg-range-picker"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
